module.exports = __webpack_public_path__ + "img/rampon_md.f57c307a.jpg";